import * as service from './service'
export default {
  namespace: 'orderCancelReason',
  state: {
    demoData: {}
  },
  effects: {
    * getOrderCancelReasons ({ payload }, { call, put }) {
      const res = yield call(service.getOrderCancelReasons, payload)
      return res.data.data
    },
    * abortOrder ({ payload }, { call, put }) {
      const res = yield call(service.abortOrder, payload)
      return res.data
    },
    * queryCourierChance ({ payload }, { call, put }) {
      const res = yield call(service.queryCourierChance, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
